import { io, Socket } from "socket.io-client";

const baseUrl = process.env.NEXT_PUBLIC_API_BASE_URL!.replace(/\/api$/, "");

export const chatSocket: Socket = io(baseUrl + "/chat", {
  transports: ["websocket"],
  withCredentials: true,
  path: "/socket.io",
  autoConnect: false,
});

export function connectChatSocket() {
  if (!chatSocket.connected) {
    chatSocket.connect();
  }
}

export function disconnectChatSocket() {
  if (chatSocket.connected) {
    chatSocket.disconnect();
  }
}
